import { useQueryClient } from "@tanstack/react-query";
import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import { getApiKeyForSidePanel } from "components/SidePanel/DetailSidePanel";
import { ExtractedPassengerCard } from "extractorSession/ExtractedPassengerCard";
import { extractorSessionSections } from "extractorSession/extractorSessionSections";
import { extractorSessionListQueryKey } from "extractorSession/list/useExtractorSessionCacheSync";
import { useExtractorSessionDetail } from "extractorSession/useExtractorSessionDetail";
import React from "react";
import { flightFromAiSidePanelApiKey } from "./flightFromAiSidePanelConstants";

interface FlightFromAiSidePanelDetailsProps {
  data: server.dto.ExtractedFlight
}

export const FlightFromAiSidePanelDetails = (props: FlightFromAiSidePanelDetailsProps) => {
  const queryClient = useQueryClient();

  const {
    state,
    onValueChanged,
    getUpdateExtractedFlightInstruction,
  } = useExtractorSessionDetail(
    props.data
  );

  const onSuccessfulUpdate = async () => {
    queryClient.invalidateQueries({ queryKey: extractorSessionListQueryKey });
    queryClient.invalidateQueries({ queryKey: getApiKeyForSidePanel(flightFromAiSidePanelApiKey, props.data.extractedFlightId) });
  }

  const [flightSection, ...otherSections] = extractorSessionSections(state, getUpdateExtractedFlightInstruction);
  const sections = [{ ...flightSection, hideTitle: true }, ...otherSections];

  return <SidePanelDetailSectionTemplate
    isInPageEditable
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdate}
    sections={sections}
    additionalContent={<>
      <h3>{RESX.Flight.Passengers}</h3>
      <div className="passengers-list">
        {props.data.passengers.map(p => <ExtractedPassengerCard
          key={p.extractedFlightPassengerId}
          passenger={p}
          isInPageEditable
          onSuccessfulUpdate={onSuccessfulUpdate}
        />)}
      </div>
    </>}
  />
}
